export interface Project {
  id: string;
  title: string;
  description: string;
  image: string;
  url: string;
  category: string;
  featured: boolean;
  technologies: string[];
}

export interface ProjectsData {
  projects: Project[];
  description: string;
}

export const projectsData: ProjectsData = {
  description: "Here are a few of my standout projects:",
  projects: [
    {
      id: "moodmade",
      title: "MoodMade",
      description:
        "Cross-platform mood-tracking & mental health app with AI-powered insights and premium membership.",
      image: "/assets/images/projects/blog.jpg",
      url: "https://play.google.com/store/apps/details?id=com.moodmademobile",
      category: "Mobile Application",
      featured: true,
      technologies: [
        "React Native",
        "NestJS",
        "MongoDB",
        "Redis",
        "Firebase",
        "S3",
      ],
    },
    {
      id: "onspace",
      title: "OnSpace",
      description:
        "Smart parking management system including CMS and Mobile App.",
      image: "/assets/images/projects/sync-up.jpg",
      url: "#",
      category: "Full Stack",
      featured: true,
      technologies: [
        "NestJS",
        "React Native",
        "MongoDB",
        "Redis",
        "Docker",
        "GitHub Actions",
      ],
    },
    {
      id: "tica-live",
      title: "Tica Live",
      description:
        "Real-time social livestream platform with video calls and interactions.",
      image: "/assets/images/projects/pod-foods.jpg",
      url: "#",
      category: "Full Stack",
      featured: true,
      technologies: [
        "React Native",
        "NestJS",
        "WebRTC",
        "Mediasoup",
        "Socket.IO",
      ],
    },
    {
      id: "nestjs-boilerplate",
      title: "NestJS Boilerplate CLI",
      description: "Open-source NestJS boilerplate CLI published on npm.",
      image: "/assets/images/projects/mern-stack-pro.jpg",
      url: "https://www.npmjs.com/package/nestjs-boilerplate-cli",
      category: "Open Source",
      featured: true,
      technologies: ["NestJS", "Node.js", "TypeScript", "CLI"],
    },
  ],
};
